<template>
    <app-modal @close="$emit('close')">
        <template #header>
            <p
                v-t="content.title || 'Community.new_event'"
                class="is-size-5 has-text-centered has-text-black"
            />
        </template>
        <template #side-menu>
            <main class="menu">
                <ul class="menu-list px-0 pt-3">
                    <div v-for="section in availableSections" :key="section">
                        <li
                            class="has-text-weight-bold is-size-6 mb-1 px-3 is-clickable"
                            @click="changeSection(section)"
                        >
                            <div class="level is-mobile">
                                <div class="level-left is-shrinkable">
                                    <div class="level-item is-shrinkable">
                                        <p
                                            v-t="'Constants.EVENT_' + section"
                                            :class="
                                                activeSection == section
                                                    ? 'has-text-primary'
                                                    : 'has-text-grey'
                                            "
                                            class="is-relative"
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>

                        <hr
                            class="navbar-divider has-background-grey-lighter"
                        />
                    </div>
                </ul>
            </main>
        </template>
        <template #main-content>
            <section class="info-section">
                <div
                    v-if="activeSection == 'INFORMATION'"
                    class="columns is-marginless px-4 py-4"
                >
                    <div class="column">
                        <div class="field">
                            <p
                                v-t="'projectConfiguration.project_title'"
                                class="label has-text-grey"
                            />
                            <p class="control">
                                <input
                                    v-model="content.title"
                                    :placeholder="
                                        $t('project_title_input_placeholder')
                                    "
                                    class="input"
                                    type="text"
                                />
                            </p>
                        </div>

                        <div class="field">
                            <p
                                v-t="'projectConfiguration.project_description'"
                                class="label has-text-grey"
                            />
                            <p class="control">
                                <textarea
                                    v-model="content.description"
                                    :placeholder="
                                        $t(
                                            'project_description_input_placeholder'
                                        )
                                    "
                                    class="textarea"
                                />
                            </p>
                        </div>

                        <div class="field">
                            <p
                                v-t="'Community.event_color'"
                                class="label has-text-grey"
                            />
                            <p class="control">
                                <!--<input
                  v-model="content.color"
                  :placeholder="$t('project_title_input_placeholder')"
                  class="input"
                  type="text"
                />-->
                                <v-swatches
                                    :value="eventColor"
                                    :swatches="swatches"
                                    :swatch-size="24"
                                    inline
                                    @input="changeColor"
                                ></v-swatches>
                            </p>
                        </div>
                    </div>
                </div>

                <div
                    v-if="activeSection == 'LINK'"
                    class="columns is-marginless px-4 py-4"
                >
                    <div class="column">
                        <p class="label has-text-grey">URL</p>
                        <InputURLButton
                            v-model="content.url"
                            :placeholder="$t('project_url_input_placeholder')"
                            :custom-title-active="true"
                        />
                    </div>
                </div>

                <div
                    v-if="activeSection == 'DATES'"
                    class="columns is-marginless px-4 py-4"
                >
                    <div class="column">
                        <vc-date-picker
                            v-model="content.range.start"
                            :min-date="minDate"
                            :masks="masks"
                            :locale="$i18n.locale"
                            :mode="'dateTime'"
                            is24hr
                            is-expanded
                        />
                    </div>
                </div>

                <input-single-image
                    v-if="activeSection == 'IMAGE'"
                    slot="input"
                    v-model="content.image"
                    :placeholder="placeholder"
                    :from-clipboard="fromClipboard"
                    :paste-value="pasteValue"
                    @uploading="
                        uploading = true;
                        hasErrors = false;
                        errorDescription = null;
                    "
                    @error="handleError"
                    @valid="(hasErrors = false), (errorDescription = null)"
                    @input="
                        uploading = false;
                        errorDescription = null;
                    "
                />

                <div
                    v-if="activeSection == 'SHARE'"
                    class="columns is-marginless px-4 py-4"
                >
                    <div class="column">
                        <div class="field">
                            <p
                                v-t="'Community.share_in_feed'"
                                class="label has-text-grey"
                            />
                            <div class="control">
                                <div
                                    class="select is-fullwidth is-very-light-pink-two has-text-black"
                                >
                                    <select
                                        v-model="content.share"
                                        :disabled="content.post"
                                    >
                                        <option
                                            v-for="option in availableShareOptions"
                                            :key="option"
                                            v-t="
                                                'Constants.EVENT_SHARE_OPTION_' +
                                                option
                                            "
                                            :value="option"
                                            class="has-text-black"
                                        />
                                    </select>
                                </div>
                            </div>

                            <input-rich-text
                                v-if="content.share != 'NONE'"
                                v-model="content.postMessage"
                                :editable="isEditable"
                                :placeholder="
                                    $t('Community.message_placeholder')
                                "
                                class="mt-4"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="has-text-centered">
                    <button
                        v-t="'Buttons.cancel'"
                        class="button is-black is-uppercase px-6 mx-2"
                        @click="ignoreChanges"
                    />
                    <button
                        v-if="(activeSection != 'SHARE') & (editing === false)"
                        v-t="'Buttons.next'"
                        class="button is-primary is-uppercase px-6 mx-2"
                        @click="goNext()"
                    />
                    <button
                        v-else
                        v-t="'Buttons.save'"
                        :class="{ 'is-loading': savingChanges }"
                        class="button is-primary is-uppercase px-6 mx-2"
                        @click="$emit('saveChanges', content)"
                    />
                </div>
            </section>
        </template>
    </app-modal>
</template>

<script>
import AppModal from '@/components/AppModal';
import InputSingleImage from '@/components/InputSingleImage';
import InputURLButton from '@/components/InputURLButton';
import _ from 'underscore';
import VSwatches from 'vue-swatches';
import InputRichText from '@/components/InputRichText';

export default {
    components: {
        AppModal,
        InputSingleImage,
        InputURLButton,
        VSwatches,
        InputRichText,
    },
    props: {
        savingChanges: {
            type: Boolean,
            default: false,
        },
        event: {
            type: Object,
            default() {
                return {
                    title: null,
                    range: {
                        start: new Date(),
                        end: new Date(),
                    },
                    color: 'bg-blue-500',
                    share: 'NONE',
                };
            },
        },
        editing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            minDate: new Date(),
            masks: {
                input: 'DD-MM-YYYY h:mm A',
            },
            activeSection: 'INFORMATION',
            placeholder: '',
            fromClipboard: false,
            inputValue: undefined,
            uploading: false,
            hasErrors: false,
            pasteValue: undefined,
            errorDescription: undefined,
            content: this.event,
            originalContent: JSON.parse(JSON.stringify(this.event)),
            defaultAvailableSections: [
                'INFORMATION',
                'LINK',
                'DATES',
                'IMAGE',
                'SHARE',
            ],
            color: null,
            swatches: [
                { color: '#4398e1', showBorder: true },
                { color: '#dfac2d', showBorder: true },
                { color: '#9761c6', showBorder: true },
                { color: '#90be61', showBorder: true },
                { color: '#ce527c', showBorder: true },
                { color: '#cbc02e', showBorder: true },
            ],
            defaultAvailableShareOptions: [
                'NONE',
                'IMMEDIATLY',
                '5DAYS',
                '2DAYS',
            ],
        };
    },
    computed: {
        eventColor() {
            if (this.content.color === 'bg-blue-500') {
                return '#4398e1';
            }
            return '#' + this.content.color.substring(9);
        },
        availableShareOptions() {
            const actualDate = new Date();
            const availableShareOptions = JSON.parse(
                JSON.stringify(this.defaultAvailableShareOptions)
            );
            let eventDays = 0;
            if (typeof this.content.range.start.getTime === 'function') {
                eventDays =
                    this.content.range.start.getTime() / 1000 / 60 / 60 / 24;
            } else {
                eventDays =
                    new Date(this.content.range.start).getTime() /
                    1000 /
                    60 /
                    60 /
                    24;
            }

            const nowDays = actualDate.getTime() / 1000 / 60 / 60 / 24;
            if (eventDays - 5 <= nowDays) {
                const index = availableShareOptions.indexOf('5DAYS');
                if (index > -1) {
                    availableShareOptions.splice(index, 1);
                }
            }
            if (eventDays - 2 <= nowDays) {
                const index = availableShareOptions.indexOf('2DAYS');
                if (index > -1) {
                    availableShareOptions.splice(index, 1);
                }
            }
            return availableShareOptions;
        },
        isEditable() {
            if (!this.content.post || this.availableShareOptions.length > 2) {
                console.log(this.content.post);
                console.log();
                return true;
            }
            return false;
        },
        availableSections() {
            const availableSections = JSON.parse(
                JSON.stringify(this.defaultAvailableSections)
            );
            if (this.content.post) {
                const index = availableSections.indexOf('SHARE');
                if (index > -1) {
                    availableSections.splice(index, 1);
                }
            }
            return availableSections;
        },
    },
    methods: {
        changeSection(section) {
            this.activeSection = section;
        },
        handleError(err) {
            this.hasErrors = true;
            this.uploading = false;
            this.errorDescription = this.$t(`Error.${err}`);
        },
        goNext() {
            const activeIndex = this.availableSections.indexOf(
                this.activeSection
            );
            this.changeSection(this.availableSections[activeIndex + 1]);
        },
        ignoreChanges() {
            if (true === this.editing) {
                this.content = this.originalContent;
                this.$store.commit(
                    'UPDATE_COMMUNITY_EVENT',
                    this.originalContent
                );
            }
            this.$emit('close');
        },
        changeColor(newColor) {
            this.content.color = 'bg-color-' + newColor.substring(1);
        },
    },
};
</script>

<style scoped>
.close {
    /*bottom: 2rem;*/
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 0;
    height: 20px;
    max-height: 20px;
    max-width: 20px;
    min-height: 20px;
    min-width: 20px;
    outline: none;
    position: relative;
    vertical-align: top;
    width: 20px;
}
.info-section {
    min-height: 50vh;
}
.separator {
    margin: 2rem -2rem;
}

/deep/.vue-swatches__swatch {
    position: relative;
    display: inline-block;
    font-size: 0;
}
/deep/.vue-swatches__swatch.vue-swatches__swatch--border,
.vue-swatches__swatch.vue-swatches__swatch--selected {
    box-shadow: inset 0 0 2px rgb(0 0 0 / 75%);
}
/deep/.vue-swatches--has-children-centered {
    display: flex;
    align-items: center;
    justify-content: center;
}
/deep/.vue-swatches__check__wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
}
/deep/.vue-swatches__check__circle {
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.15);
}
/deep/.vue-swatches__check__path {
    fill: #fff;
}
</style>
